// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__1bMYu","ldsHourglass":"Spinner_ldsHourglass__13bl_","lds-hourglass":"Spinner_lds-hourglass__2yq83"};